(ns ncr.fragment.attachments-backend
  (:require
   ["print-js" :as printJS]
   ["jszip-utils" :as JSZipUtils]
   [cljs.core.async :as async :refer-macros [go]]
   [clojure.core.match :refer [match]]
   [cljs-http.client :as http]
   [tick.core :as t]
   [lambdaisland.glogi :as log]
   [ncr.etc.alert :as a]
   [ncr.etc.util :as u]
   [ncr.backend :as b]))

(defn !upload [file progress]
  (let
    [file-name (.-name file)
     length (.-size file)
     last-modified (-> (.-lastModified file) (t/instant) (t/date-time) (t/format))
     progress-base {:title "Uploading..." :body file-name}]
    (go
      (async/>! progress progress-base)

      (u/error-m
        [{attachment-id :id url :url params :params}
         (<!
           (b/!mutation
             [:upload_create
              {:length length :fileName file-name :lastModified last-modified}
              [:id :url [:params [:name :value]]]]))

         _post
         (u/http-error
           (<!
             (http/post url
               {:with-credentials? false
                :progress
                (let [ch (async/chan)]
                  (async/go-loop []
                    (when-let [{:keys [loaded total]} (<! ch)]
                      (async/>! progress
                        (merge progress-base
                          {:progress-value (* 100 (/ loaded total))}))
                      (recur)))
                  ch)
                :multipart-params
                (into []
                  (concat
                    (map
                      (fn [{:keys [name value]}]
                        [name value]) params)
                    [["file" file]]))})))]
        [attachment-id file-name]))))

(defn !upload* [file]
  (let [progress (a/progress {})]
    (a/!operation* {} progress
      (!upload file progress))))


(defn !download-url [reference-id attachment-id disposition]
  (go
    (u/error-m
      [url
       (async/<!
         (b/!query
           [:attachment_download
            {:reference reference-id
             :attachment attachment-id
             :disposition disposition}]))]
      url)))

(defn download! [reference-id attachment-id disposition]
  (go
    (u/error-m
      [url (async/<! (!download-url reference-id attachment-id disposition))]
      (u/open-link! url disposition))))

(defn print! [reference-id id]
  (go
    (u/error-m
      [url (<! (!download-url reference-id id :INLINE))
       array-buffer (<! (u/promise->ch #(JSZipUtils/getBinaryContent url)))
       blob (js/Blob. #js[array-buffer])
       object-url (.createObjectURL js/URL blob)
       ; remember to revoke url,
       ; see https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL_static
       revoke! #(.revokeObjectURL js/URL object-url)]
      (printJS (clj->js
                 {:printable object-url
                  :onPrintDialogClose revoke!
                  :onError revoke!})))))

(defn resubmit-for-ocr! [reference-id attachment-id]
  (go
    (<!
      (b/!mutation
        [:schedule_job
         {:jobName "ocr/textract"
          :data
          (u/transit-write
            {:reference/id reference-id :attachment/id attachment-id})}]))))
